export default "__VITE_ASSET__nbFMMDng__"